import { Form, Input, Flex, theme } from "antd";
import { PhoneNumberInput } from "@/components/phone-number-input";
import { t } from "i18next";

export const NewContactCard: React.FC<{
    disabled?: boolean;
    onBlurValidate?: () => void;
}> = ({ disabled, onBlurValidate }) => {
    const { token } = theme.useToken();

    return (
        <>
            <Flex gap={8} justify="space-between">
                <Form.Item
                    style={{ flex: 1 }}
                    label={
                        <span style={{ color: token.colorTextTertiary }}>
                            {t("name")}
                        </span>
                    }
                    name="firstname"
                    hasFeedback
                    rules={[
                        {
                            required: true,
                            whitespace: true,
                            message: t("message.error.inputEmpty"),
                        },
                    ]}
                >
                    <Input disabled={disabled} type="text" />
                </Form.Item>

                <Form.Item
                    style={{ flex: 1 }}
                    label={
                        <span style={{ color: token.colorTextTertiary }}>
                            {t("lastname")}
                        </span>
                    }
                    name="lastname"
                    hasFeedback
                    rules={[
                        {
                            required: true,
                            message: t("message.error.inputEmpty"),
                        },
                    ]}
                >
                    <Input disabled={disabled} type="text" />
                </Form.Item>
            </Flex>

            <Form.Item
                label={
                    <span style={{ color: token.colorTextTertiary }}>
                        {t("pages.login.fields.email")}
                    </span>
                }
                name="email"
                dependencies={["whatsapp"]}
                hasFeedback
                rules={[
                    ({ getFieldValue }) => ({
                        validator: async (_, value) => {
                            const whatsapp = getFieldValue("whatsapp");
                            const phoneDigits = String(whatsapp ?? "").replace(
                                /\D/g,
                                "",
                            );
                            const hasWhatsapp = phoneDigits.length > 0;
                            const email = String(value ?? "").trim();
                            const hasEmail = email.length > 0;

                            if (!hasWhatsapp && !hasEmail) {
                                return Promise.reject(
                                    new Error(
                                        t(
                                            "contacts.address.validation.emailOrWhatsappRequired",
                                        ) ?? "Ingresá email o WhatsApp",
                                    ),
                                );
                            }

                            return Promise.resolve();
                        },
                    }),
                    {
                        validator: async (_, value) => {
                            const email = String(value ?? "").trim();
                            if (!email) return Promise.resolve();
                            const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                                email,
                            );
                            if (!valid) {
                                return Promise.reject(
                                    new Error(
                                        t("pages.register.errors.validEmail"),
                                    ),
                                );
                            }
                            return Promise.resolve();
                        },
                    },
                ]}
            >
                <Input
                    disabled={disabled}
                    type="email"
                    onBlur={onBlurValidate}
                />
            </Form.Item>

            <Form.Item
                label={
                    <span style={{ color: token.colorTextTertiary }}>
                        WhatsApp
                    </span>
                }
                name="whatsapp"
                dependencies={["email"]}
                hasFeedback
                rules={[
                    ({ getFieldValue }) => ({
                        validator: async (_, value) => {
                            const email = getFieldValue("email");
                            const hasEmail = !!String(email ?? "").trim();
                            const phoneDigits = String(value ?? "").replace(
                                /\D/g,
                                "",
                            );
                            const hasWhatsapp = phoneDigits.length > 0;

                            if (!hasEmail && !hasWhatsapp) {
                                return Promise.reject(
                                    new Error(
                                        t(
                                            "contacts.address.validation.emailOrWhatsappRequired",
                                        ) ?? "Ingresá email o WhatsApp",
                                    ),
                                );
                            }

                            return Promise.resolve();
                        },
                    }),
                    {
                        validator: async (_, value) => {
                            const phoneDigits = String(value ?? "").replace(
                                /\D/g,
                                "",
                            );
                            if (!phoneDigits) return Promise.resolve();
                            if (phoneDigits.length < 11) {
                                return Promise.reject(
                                    new Error(
                                        t(
                                            "contacts.address.validation.whatsapplength",
                                        ),
                                    ),
                                );
                            }
                            return Promise.resolve();
                        },
                    },
                ]}
            >
                <PhoneNumberInput
                    disabled={disabled}
                    inputProps={{ onBlur: onBlurValidate }}
                />
            </Form.Item>
        </>
    );
};
